import { Route } from 'src/routes/Route'

export const ConfirmPaymentRoute = Route({
  path: '/confirm-payment',
})

export type ConfirmPaymentRoute = Route<typeof ConfirmPaymentRoute>
